module.exports = __webpack_public_path__ + "static/media/girl-21.91305798.svg";